import styled from '@emotion/styled'
import { Checkbox as AntdCheckbox, Select as AntdSelect } from 'antd'

export const Checkbox = styled(AntdCheckbox)``

export const Select = styled(AntdSelect)`
  .ant-select-selector {
    height: 40px !important;
    padding: 5px 16px !important;
    border-radius: 8px !important;
  }

  .ant-select-selection-item {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    padding: 5px 0px !important;
  }

  .ant-select-selection-search {
    padding: 5px 0px !important;
  }
`
